module.exports = __webpack_public_path__ + "static/arrow-up.f3d8451bcb7608fcfe511fd09c57a920.svg";